export default {
  'Teklif Formu': 'Teklif Formu',
  'Kayıtlı Teklifler': 'Kayıtlı Teklifler',
  'Kullanıcı Adı': 'Kullanıcı Adı',
  'Şifre': 'Şifre',
  'Giriş Yap': 'Giriş Yap',
  'Çıkış Yap': 'Çıkış Yap',
  'KDV Oranı': 'KDV Oranı',
  'Teklif Durumu': 'Teklif Durumu',
  'Kaydet': 'Kaydet',
  'PDF Önizleme': 'PDF Önizleme',
  'PDF\'ye Aktar': "PDF'ye Aktar",
  'E-posta ile Gönder': 'E-posta ile Gönder',
  'Alıcı': 'Alıcı',
  'Tarih': 'Tarih',
  'Genel Toplam': 'Genel Toplam',
  'Not': 'Not',
  'KDV': 'KDV',
  'Alt Toplam': 'Alt Toplam',
  'Açıklama': 'Açıklama',
  'Ürün Adı': 'Ürün Adı',
  'SUT Kodu': 'SUT Kodu',
  'Birim Alış Fiyatı': 'Birim Alış Fiyatı',
  'Sipariş Adedi': 'Sipariş Adedi',
  'Promosyon Ürün': 'Promosyon Ürün',
  'Toplam Adet': 'Toplam Adet',
  'Sipariş Tutarı': 'Sipariş Tutarı',
  'Durum': 'Durum',
  'Kabul Edildi': 'Kabul Edildi',
  'Reddedildi': 'Reddedildi',
  'Gönderildi': 'Gönderildi',
  'Taslak': 'Taslak',
  'Yurtiçi': 'Yurtiçi',
  'Yurtdışı': 'Yurtdışı',
  'Sipariş Oluştur': 'Sipariş Oluştur',
  'Ürün Sıralaması': 'Ürün Sıralaması',
  'Ürünler popülerlik ve önem düzeyine göre sıralanmıştır': 'Ürünler popülerlik ve önem düzeyine göre sıralanmıştır',
  'Kardiyoloji ve damar cerrahisi ürünleri öncelikli olarak gösterilmektedir': 'Kardiyoloji ve damar cerrahisi ürünleri öncelikli olarak gösterilmektedir',
  'Ürün adı, açıklama veya barkod ile ara...': 'Ürün adı, açıklama veya barkod ile ara...',
  'Tüm Kategoriler': 'Tüm Kategoriler',
  'Kutu görünüm': 'Kutu görünüm',
  'Liste görünüm': 'Liste görünüm',
  'Aradığınız kriterlere uygun ürün bulunamadı': 'Aradığınız kriterlere uygun ürün bulunamadı',
  'Ürün Adı Yok': 'Ürün Adı Yok',
  'Kategori Yok': 'Kategori Yok',
  'Açıklama yok': 'Açıklama yok',
  'Firma Bilgilerini Doldurun': 'Firma Bilgilerini Doldurun',
  'Sepete Ekle': 'Sepete Ekle',
  'Firma Bilgileri': 'Firma Bilgileri',
  'Ülke Seçimi': 'Ülke Seçimi',
  'Türkiye': 'Türkiye',
  'Almanya': 'Almanya',
  'ABD': 'ABD',
  'Firma Ünvanı': 'Firma Ünvanı',
  'Vergi Dairesi': 'Vergi Dairesi',
  'Vergi Numarası': 'Vergi Numarası',
  'Adres': 'Adres',
  'Şehir': 'Şehir',
  'Şehir Seçimi': 'Şehir Seçimi',
  'Şehir adı ara...': 'Şehir adı ara...',
  'Aradığınız şehir bulunamadı': 'Aradığınız şehir bulunamadı',
  'Bu ülke için şehir verisi bulunamadı': 'Bu ülke için şehir verisi bulunamadı',
  'şehir bulundu': '{{count}} şehir bulundu',
  'Yetkili': 'Yetkili',
  'Telefon': 'Telefon',
  'Email': 'Email',
  'Bilgileri İlet': 'Bilgileri İlet',
  'Lütfen eksik alanları doldurun': 'Lütfen eksik alanları doldurun',
  'Firma kaydedilemedi': 'Firma kaydedilemedi',
  'Firma bilgileri başarıyla iletildi': 'Firma bilgileri başarıyla iletildi',
  'Firma Ünvanı:': 'Firma Ünvanı:',
  'Yetkili Kişi:': 'Yetkili Kişi:',
  'Sepetiniz': 'Sepetiniz',
  'Sepetiniz boş': 'Sepetiniz boş',
  'adet': 'adet',
  'Düzenle': 'Düzenle',
  'Kaldır': 'Kaldır',
  'Siparişi Tamamla': 'Siparişi Tamamla',
  'Lütfen önce firma bilgilerinizi eksiksiz iletin': 'Lütfen önce firma bilgilerinizi eksiksiz iletin',
  'Sipariş başarıyla kaydedildi': 'Sipariş başarıyla kaydedildi',
  'Email adresinize hoş geldiniz mesajı ve erişim linki gönderildi': 'Email adresinize hoş geldiniz mesajı ve erişim linki gönderildi',
  'Link 3 gün geçerlidir': 'Link 3 gün geçerlidir',
  'Sipariş kaydedilemedi': 'Sipariş kaydedilemedi',
  'Firma Bilgileri Gerekli': 'Firma Bilgileri Gerekli',
  'Sepete eklemek için önce firma bilgilerinizi doldurun': 'Sepete eklemek için önce firma bilgilerinizi doldurun',
  'Önce Bilgileri Doldurun': 'Önce Bilgileri Doldurun',
  'Uyarı': 'Uyarı',
  'Sepete eklemek için önce firma bilgilerinizi doldurmanız gerekmektedir': 'Sepete eklemek için önce firma bilgilerinizi doldurmanız gerekmektedir',
  'SUT Kütüphanesi Tanımı': 'SUT Kütüphanesi Tanımı',
  'SUT Kodu:': 'SUT Kodu:',
  'Standart': 'Standart',
  'Açıklama (isteğe bağlı)': 'Açıklama (isteğe bağlı)',
  'Partner Ol': 'Partner Ol',
  'Partner başvuru popup açılacak': 'Partner başvuru popup açılacak',
  'Dil': 'Dil',
  'E-posta': 'E-posta',
  'globalPartnersTitle': 'Dünya Genelinde 30.000 Partner ile İş Birliği',
  'globalPartnersDesc': '30.000 partnerden oluşan geniş küresel ağımız, ortak inovasyon, bilgi paylaşımı ve karşılıklı başarıyı teşvik ediyor. Birlikte çalışarak, hasta bakımının sınırlarını sürekli genişletiyoruz.',
  'bayiBasvuru': 'INVAMED Partner Başvuru Formu',
  'bayiBasvuruDesc': 'INVAMED partner ağına katılmak için aşağıdaki formu doldurun. Başvurunuz incelendikten sonra size geri dönüş yapılacaktır.',
  'applyFields': {
    'firma': 'Firma Ünvanı',
    'vergiNo': 'Vergi Dairesi / Vergi No',
    'yetkili': 'Yetkili Adı Soyadı',
    'telefon': 'Telefon',
    'email': 'E-posta',
    'adres': 'Adres',
    'sektor': 'Faaliyet Alanı / Sektör',
    'sicil': 'Ticaret Sicil No',
    'web': 'Web Sitesi'
  },
  'Şifremi Unuttum': 'Şifremi Unuttum',
  'Demo Giriş': 'Demo Giriş',
  'Bayi Başvurusu': 'Bayi Başvurusu',
  'Yardım': 'Yardım',
  'Giriş yapılıyor...': 'Giriş yapılıyor...',
  'E-posta veya şifre hatalı': 'E-posta veya şifre hatalı',
  'Şifre sıfırlama e-postası gönderildi': 'Şifre sıfırlama e-postası gönderildi',
  'E-posta gönderilemedi': 'E-posta gönderilemedi',
  'Vergi Dairesi / Vergi No': 'Vergi Dairesi / Vergi No',
  'Yetkili Adı Soyadı': 'Yetkili Adı Soyadı',
  'Faaliyet Alanı / Sektör': 'Faaliyet Alanı / Sektör',
  'Ticaret Sicil No': 'Ticaret Sicil No',
  'Web Sitesi': 'Web Sitesi',
  'Şehir Seçimi': 'Şehir Seçimi',
  'Firma / Sağlık Profesyoneli': 'Firma / Sağlık Profesyoneli',
  'Yetkili Kişi': 'Yetkili Kişi',
  'Telefon': 'Telefon',
  'E-posta': 'E-posta',
  'E-Posta': 'E-posta',
  'Temel Bilgiler': 'Temel Bilgiler',
  'Ek Bilgiler': 'Ek Bilgiler',
  'Faaliyet Alanı / Sektör': 'Faaliyet Alanı / Sektör',
  'Ülke Seçimi': 'Ülke Seçimi',
  'Ülke adı veya kodu ara...': 'Ülke adı veya kodu ara...',
  'region.Avrupa': 'Avrupa',
  'region.Amerika': 'Amerika',
  'region.Asya': 'Asya',
  'region.Afrika': 'Afrika',
  'region.Okyanusya': 'Okyanusya',
  'region.Diğer': 'Diğer',
  // Ülke çevirileri
  'country.TR': 'Türkiye',
  'country.AL': 'Arnavutluk',
  'country.DE': 'Almanya',
  'country.AD': 'Andorra',
  'country.AT': 'Avusturya',
  'country.BY': 'Beyaz Rusya',
  'country.BE': 'Belçika',
  'country.BA': 'Bosna Hersek',
  'country.BG': 'Bulgaristan',
  'country.CZ': 'Çekya',
  'country.DK': 'Danimarka',
  'country.EE': 'Estonya',
  'country.FO': 'Faroe Adaları',
  'country.FI': 'Finlandiya',
  'country.FR': 'Fransa',
  'country.GI': 'Cebelitarık',
  'country.GR': 'Yunanistan',
  'country.GG': 'Guernsey',
  'country.HR': 'Hırvatistan',
  'country.NL': 'Hollanda',
  'country.IE': 'İrlanda',
  'country.ES': 'İspanya',
  'country.SE': 'İsveç',
  'country.CH': 'İsviçre',
  'country.IT': 'İtalya',
  'country.IS': 'İzlanda',
  'country.JE': 'Jersey',
  'country.ME': 'Karadağ',
  'country.LV': 'Letonya',
  'country.LI': 'Lihtenştayn',
  'country.LT': 'Litvanya',
  'country.LU': 'Lüksemburg',
  'country.HU': 'Macaristan',
  'country.MT': 'Malta',
  'country.IM': 'Man Adası',
  'country.MD': 'Moldova',
  'country.MC': 'Monako',
  'country.MK': 'Kuzey Makedonya',
  'country.NO': 'Norveç',
  'country.PL': 'Polonya',
  'country.PT': 'Portekiz',
  'country.RO': 'Romanya',
  'country.RU': 'Rusya',
  'country.SM': 'San Marino',
  'country.RS': 'Sırbistan',
  'country.SK': 'Slovakya',
  'country.SI': 'Slovenya',
  'country.SJ': 'Svalbard ve Jan Mayen',
  'country.UA': 'Ukrayna',
  'country.GB': 'Birleşik Krallık',
  'country.VA': 'Vatikan',
  'country.AX': 'Åland Adaları',
  'country.US': 'Amerika Birleşik Devletleri',
  'country.AS': 'Amerikan Samoası',
  'country.AI': 'Anguilla',
  'country.AG': 'Antigua ve Barbuda',
  'country.AR': 'Arjantin',
  'country.AW': 'Aruba',
  'country.BS': 'Bahamalar',
  'country.BB': 'Barbados',
  'country.BZ': 'Belize',
  'country.BM': 'Bermuda',
  'country.BO': 'Bolivya',
  'country.BR': 'Brezilya',
  'country.VG': 'Britanya Virjin Adaları',
  'country.CA': 'Kanada',
  'country.KY': 'Cayman Adaları',
  'country.CL': 'Şili',
  'country.CO': 'Kolombiya',
  'country.CR': 'Kosta Rika',
  'country.CU': 'Küba',
  'country.CW': 'Curaçao',
  'country.DM': 'Dominika',
  'country.DO': 'Dominik Cumhuriyeti',
  'country.EC': 'Ekvador',
  'country.SV': 'El Salvador',
  'country.FK': 'Falkland Adaları',
  'country.GF': 'Fransız Guyanası',
  'country.GD': 'Grenada',
  'country.GL': 'Grönland',
  'country.GP': 'Guadeloupe',
  'country.GT': 'Guatemala',
  'country.GY': 'Guyana',
  'country.HT': 'Haiti',
  'country.HN': 'Honduras',
  'country.JM': 'Jamaika',
  'country.MQ': 'Martinik',
  'country.MX': 'Meksika',
  'country.MS': 'Montserrat',
  'country.NI': 'Nikaragua',
  'country.PA': 'Panama',
  'country.PY': 'Paraguay',
  'country.PE': 'Peru',
  'country.PR': 'Porto Riko',
  'country.BL': 'Saint Barthélemy',
  'country.KN': 'Saint Kitts ve Nevis',
  'country.LC': 'Saint Lucia',
  'country.MF': 'Saint Martin',
  'country.PM': 'Saint Pierre ve Miquelon',
  'country.VC': 'Saint Vincent ve Grenadinler',
  'country.SX': 'Sint Maarten',
  'country.SR': 'Surinam',
  'country.TT': 'Trinidad ve Tobago',
  'country.TC': 'Turks ve Caicos Adaları',
  'country.UY': 'Uruguay',
  'country.VE': 'Venezuela',
  'country.VI': 'Virgin Adaları (ABD)',
  'country.AF': 'Afganistan',
  'country.AZ': 'Azerbaycan',
  'country.BH': 'Bahreyn',
  'country.BD': 'Bangladeş',
  'country.AE': 'Birleşik Arap Emirlikleri',
  'country.BN': 'Brunei',
  'country.BT': 'Butan',
  'country.CN': 'Çin',
  'country.TL': 'Doğu Timor',
  'country.ID': 'Endonezya',
  'country.AM': 'Ermenistan',
  'country.PH': 'Filipinler',
  'country.PS': 'Filistin',
  'country.GE': 'Gürcistan',
  'country.KR': 'Güney Kore',
  'country.IN': 'Hindistan',
  'country.HK': 'Hong Kong',
  'country.IQ': 'Irak',
  'country.IR': 'İran',
  'country.IL': 'İsrail',
  'country.JP': 'Japonya',
  'country.KH': 'Kamboçya',
  'country.QA': 'Katar',
  'country.KZ': 'Kazakistan',
  'country.KG': 'Kırgızistan',
  'country.CY': 'Kıbrıs',
  'country.KW': 'Kuveyt',
  'country.KP': 'Kuzey Kore',
  'country.LA': 'Laos',
  'country.LB': 'Lübnan',
  'country.MO': 'Makao',
  'country.MV': 'Maldivler',
  'country.MY': 'Malezya',
  'country.MM': 'Myanmar',
  'country.MN': 'Moğolistan',
  'country.NP': 'Nepal',
  'country.UZ': 'Özbekistan',
  'country.PK': 'Pakistan',
  'country.SG': 'Singapur',
  'country.LK': 'Sri Lanka',
  'country.SY': 'Suriye',
  'country.SA': 'Suudi Arabistan',
  'country.TJ': 'Tacikistan',
  'country.TH': 'Tayland',
  'country.TW': 'Tayvan',
  'country.TM': 'Türkmenistan',
  'country.OM': 'Umman',
  'country.JO': 'Ürdün',
  'country.VN': 'Vietnam',
  'country.YE': 'Yemen',
  'country.DZ': 'Cezayir',
  'country.AO': 'Angola',
  'country.BJ': 'Benin',
  'country.BW': 'Botsvana',
  'country.BF': 'Burkina Faso',
  'country.BI': 'Burundi',
  'country.CV': 'Cabo Verde',
  'country.CM': 'Kamerun',
  'country.CF': 'Orta Afrika Cumhuriyeti',
  'country.TD': 'Çad',
  'country.KM': 'Komorlar',
  'country.CG': 'Kongo Cumhuriyeti',
  'country.CD': 'Demokratik Kongo Cumhuriyeti',
  'country.CI': 'Fildişi Sahili',
  'country.DJ': 'Cibuti',
  'country.EG': 'Mısır',
  'country.GQ': 'Ekvator Ginesi',
  'country.ER': 'Eritre',
  'country.SZ': 'Esvatini',
  'country.ET': 'Etiyopya',
  'country.GA': 'Gabon',
  'country.GM': 'Gambiya',
  'country.GH': 'Gana',
  'country.GN': 'Gine',
  'country.GW': 'Gine-Bissau',
  'country.KE': 'Kenya',
  'country.LS': 'Lesotho',
  'country.LR': 'Liberya',
  'country.LY': 'Libya',
  'country.MG': 'Madagaskar',
  'country.MW': 'Malavi',
  'country.ML': 'Mali',
  'country.MR': 'Moritanya',
  'country.MU': 'Mauritius',
  'country.YT': 'Mayotte',
  'country.MA': 'Fas',
  'country.MZ': 'Mozambik',
  'country.NA': 'Namibya',
  'country.NE': 'Nijer',
  'country.NG': 'Nijerya',
  'country.RE': 'Réunion',
  'country.RW': 'Ruanda',
  'country.SH': 'Saint Helena',
  'country.ST': 'São Tomé ve Príncipe',
  'country.SN': 'Senegal',
  'country.SC': 'Seyşeller',
  'country.SL': 'Sierra Leone',
  'country.SO': 'Somali',
  'country.ZA': 'Güney Afrika',
  'country.SS': 'Güney Sudan',
  'country.SD': 'Sudan',
  'country.TZ': 'Tanzanya',
  'country.TG': 'Togo',
  'country.TN': 'Tunus',
  'country.UG': 'Uganda',
  'country.EH': 'Batı Sahra',
  'country.ZM': 'Zambiya',
  'country.ZW': 'Zimbabve',
  'country.AU': 'Avustralya',
  'country.CX': 'Christmas Adası',
  'country.CC': 'Cocos (Keeling) Adaları',
  'country.CK': 'Cook Adaları',
  'country.FJ': 'Fiji',
  'country.PF': 'Fransız Polinezyası',
  'country.GU': 'Guam',
  'country.HM': 'Heard Adası ve McDonald Adaları',
  'country.KI': 'Kiribati',
  'country.MH': 'Marshall Adaları',
  'country.FM': 'Mikronezya',
  'country.NR': 'Nauru',
  'country.NC': 'Yeni Kaledonya',
  'country.NZ': 'Yeni Zelanda',
  'country.NU': 'Niue',
  'country.NF': 'Norfolk Adası',
  'country.MP': 'Kuzey Mariana Adaları',
  'country.PW': 'Palau',
  'country.PG': 'Papua Yeni Gine',
  'country.PN': 'Pitcairn Adaları',
  'country.WS': 'Samoa',
  'country.SB': 'Solomon Adaları',
  'country.TK': 'Tokelau',
  'country.TO': 'Tonga',
  'country.TV': 'Tuvalu',
  'country.VU': 'Vanuatu',
  'country.WF': 'Wallis ve Futuna',
  'country.AQ': 'Antarktika',
  'country.BV': 'Bouvet Adası',
  'country.IO': 'Britanya Hint Okyanusu Toprakları',
  'country.TF': 'Fransız Güney ve Antarktika Toprakları',
  'country.GS': 'Güney Georgia ve Güney Sandwich Adaları',
  'Ticaret Sicil No': 'Ticaret Sicil No',
  'Başvuru Gönder': 'Başvuru Gönder',
  'Başvuru gönderiliyor...': 'Başvuru gönderiliyor...',
  'Başvuru başarıyla gönderildi': 'Başvuru başarıyla gönderildi',
  'Başvuru gönderilemedi': 'Başvuru gönderilemedi',
  'Sözleşme şartlarını kabul ediyorum': 'Sözleşme şartlarını kabul ediyorum',
  'Dosya Yükle': 'Dosya Yükle',
  'Dosya seçilmedi': 'Dosya seçilmedi',
  'Dosya yüklendi': 'Dosya yüklendi',
  'Dosya yüklenemedi': 'Dosya yüklenemedi',
  'Tamamla': 'Tamamla',
  'Geri': 'Geri',
  'İleri': 'İleri',
  'Kapat': 'Kapat',
  'Yardım İçeriği': 'Yardım İçeriği',
  'dil': 'Dil',
  'Üye Ol': 'Üye Ol',
  'Üye Değil Misiniz?': 'Üye Değil Misiniz?',
  'Şimdi Üye Ol': 'Şimdi Üye Ol',
  'Misafir Kullanıcı': 'Misafir Kullanıcı',
  'Hızlı Sipariş': 'Hızlı Sipariş',
  'Misafir Olarak Sipariş Verin': 'Misafir Olarak Sipariş Verin',
  'Giriş yapmadan hızlıca ürünlerinizi seçin ve siparişinizi oluşturun': 'Giriş yapmadan hızlıca ürünlerinizi seçin ve siparişinizi oluşturun',
  'Giriş yapmadan sipariş oluşturun': 'Giriş yapmadan sipariş oluşturun',
  'Anında Erişim': 'Anında Erişim',
  'Tüm ürünlere anında erişim': 'Tüm ürünlere anında erişim',
  'Güvenli İşlem': 'Güvenli İşlem',
  'SSL korumalı güvenli sipariş': 'SSL korumalı güvenli sipariş',
  'Misafir Olarak Sipariş Oluştur': 'Misafir Olarak Sipariş Oluştur',
  'İpucu:': 'İpucu:',
  'Daha fazla özellik için üye olun': 'Daha fazla özellik için üye olun',
  'Ücretsiz': 'Ücretsiz',
  'Hızlı': 'Hızlı',
  'Güvenli': 'Güvenli',
  'bayilikSozlesme': 'Partnerlik şartlarını ve sözleşmesini okudum, kabul ediyorum.',
  'geri': 'Geri',
  'basvuruGonder': 'Başvuruyu Gönder',
  'ileri': 'İleri',
  'sozlesmeGonderildi': 'Sözleşme E-posta Adresinize Gönderildi!',
  'sozlesmeDesc': 'Lütfen e-posta adresinize gelen INVAMED Partnerlik Sözleşmesi ve gerekli belgeleri aşağıdan yükleyin.',
  'tamamla': 'Başvuruyu Tamamla',
  'basvuruAlindi': 'Başvurunuz Alındı!',
  'basvuruAlindiDesc': 'INVAMED ekibi başvurunuzu inceleyecek ve en kısa sürede sizinle iletişime geçecektir.',
  'Başvuru Durumu': 'Başvuru Durumu',
  'Başvurunuz onay sürecindedir': 'Başvurunuz onay sürecindedir',
  'sifreSifirla': 'Şifre Sıfırlama',
  'sifreSifirlaDesc': 'Kayıtlı e-posta adresinizi girin, şifre sıfırlama talimatı gönderelim.',
  'gonder': 'Gönder',
  'talimatGonderildi': 'Talimat Gönderildi',
  'sentDesc': 'Şifre sıfırlama talimatı <b>{email}</b> adresine gönderildi. Lütfen e-postanızı kontrol edin.',
  'helpTitle': 'Nasıl Giriş Yapabilirim?',
  'helpList': [
    'INVAMED partner paneline giriş yapmak için kayıtlı e-posta adresinizi ve şifrenizi girin.',
    'Demo kullanıcı ile giriş yapmak için:',
    'Şifrenizi unuttuysanız "Şifremi Unuttum" bağlantısını kullanarak sıfırlama talebinde bulunabilirsiniz.',
    'Girişte sorun yaşıyorsanız, e-posta adresinizi ve şifrenizi doğru girdiğinizden emin olun. Hala sorun devam ediyorsa destek ekibimizle iletişime geçin.'
  ],
  'partnerlikSozlesmeTitle': 'INVAMED Partnerlik Sözleşmesi ve Şartları',
  'partnerlikSozlesmeText': `1. GENEL HÜKÜMLER

Bu sözleşme, INVAMED (bundan sonra "Şirket" olarak anılacaktır) ile partner adayı (bundan sonra "Partner" olarak anılacaktır) arasında tıbbi cihaz ve ekipman satışı konusunda işbirliği yapılması amacıyla düzenlenmiştir.

2. PARTNERLİK KOŞULLARI

2.1. Partner, tıbbi cihaz satışı konusunda yasal yetkiye sahip olmalıdır.
2.2. Partner, sağlık sektöründe faaliyet gösteren bir kuruluş olmalıdır.
2.3. Partner, gerekli lisans ve sertifikalara sahip olmalıdır.
2.4. Partner, finansal açıdan güvenilir olmalıdır.

3. TARAFLARIN YÜKÜMLÜLÜKLERİ

Şirketin Yükümlülükleri:
3.1. Kaliteli ürün ve hizmet sunmak
3.2. Teknik destek sağlamak
3.3. Eğitim ve bilgilendirme yapmak
3.4. Fiyatlandırma konusunda şeffaf olmak

Partnerin Yükümlülükleri:
3.1. Ürünleri uygun koşullarda saklamak
3.2. Müşteri hizmetlerini kaliteli şekilde sunmak
3.3. Yasal düzenlemelere uymak
3.4. Şirket markasını korumak

4. FİYATLANDIRMA VE ÖDEME

4.1. Fiyatlar Şirket tarafından belirlenir
4.2. Partner, belirlenen fiyatları korumakla yükümlüdür
4.3. Ödeme koşulları ayrıca belirlenir
4.4. Komisyon oranları performansa göre değişebilir

5. GİZLİLİK VE GÜVENLİK

5.1. Taraflar birbirlerine ait gizli bilgileri korumakla yükümlüdür
5.2. Müşteri bilgileri gizli tutulmalıdır
5.3. Veri güvenliği standartlarına uyulmalıdır

6. SÖZLEŞMENİN SÜRESİ VE FESİH

6.1. Bu sözleşme 1 yıl süreyle geçerlidir
6.2. Karşılıklı anlaşma ile uzatılabilir
6.3. 30 gün önceden bildirim ile feshedilebilir
6.4. Ciddi ihlal durumunda anında feshedilebilir

7. UYUŞMAZLIK ÇÖZÜMÜ

7.1. Uyuşmazlıklar öncelikle görüşme ile çözülmeye çalışılır
7.2. Çözülemeyen durumlarda Türkiye Cumhuriyeti mahkemeleri yetkilidir

8. YÜRÜRLÜK

Bu sözleşme taraflarca okunmuş, anlaşılmış ve kabul edilmiştir.`,
  'partnerlikSozlesmeOnay': 'Yukarıdaki INVAMED Partnerlik Sözleşmesi ve Şartlarını okudum, anladım ve kabul ediyorum. Bu sözleşmenin tüm maddelerini kabul ettiğimi ve yükümlülüklerimi yerine getireceğimi beyan ederim.',
  'sozlesmeyiGoruntule': 'Sözleşmeyi Görüntüle',
  'sozlesmeyiKapat': 'Kapat',
  'Ürün': 'Ürün',
  'Ürün eklemek için ürün listesinden seçim yapın': 'Ürün eklemek için ürün listesinden seçim yapın',
  'Etiketler': 'Etiketler',
  'Öncelikli': 'Öncelikli',
  'Ülke Seçiniz': 'Ülke Seçiniz',
  'Firma / Sağlık Profesyoneli': 'Firma / Sağlık Profesyoneli',
  'Şehir Seçiniz': 'Şehir Seçiniz',
  'Yetkili Kişi': 'Yetkili Kişi',
  'UDI Kodu': 'UDI Kodu',
  'Teklif başarıyla kaydedildi!': 'Teklif başarıyla kaydedildi!',
  'Aynı teklif zaten kayıtlı!': 'Aynı teklif zaten kayıtlı!',
  'Kullanıcı adı veya şifre hatalı!': 'Kullanıcı adı veya şifre hatalı!',
  'Teklif No': 'Teklif No',
  'Teklifler': 'Teklifler',
  'Yedeklenecek teklif yok!': 'Yedeklenecek teklif yok!',
  'Yedek dosyası indirildi.': 'Yedek dosyası indirildi.',
  'Yedek başarıyla yüklendi.': 'Yedek başarıyla yüklendi.',
  'Geçersiz veya bozuk dosya!': 'Geçersiz veya bozuk dosya!',
  'Yedekle (JSON)': 'Yedekle (JSON)',
  'Geri Yükle': 'Geri Yükle',
  'Kayıtlı teklif yok.': 'Kayıtlı teklif yok.',
  'E-posta Durumu': 'E-posta Durumu',
  'İşlemler': 'İşlemler',
  'E-posta ile gönderildi': 'E-posta ile gönderildi',
  'E-posta gönderilmedi': 'E-posta gönderilmedi',
  'Görüntüle': 'Görüntüle',
  'Sil': 'Sil',
  'Gönderildi': 'Gönderildi',
  'Gönderilmedi': 'Gönderilmedi',
  'Teklif ID bulunamadı! Lütfen tekrar deneyin.': 'Teklif ID bulunamadı! Lütfen tekrar deneyin.',
  'Lütfen partner seçiniz.': 'Lütfen partner seçiniz.',
  'Lütfen teslimat tarihi belirtiniz.': 'Lütfen teslimat tarihi belirtiniz.',
  'Proforma başarıyla oluşturuldu!': 'Proforma başarıyla oluşturuldu!',
  'Proforma oluşturuldu ancak ürün eklenemedi. Detaylar için konsolu kontrol edin.': 'Proforma oluşturuldu ancak ürün eklenemedi. Detaylar için konsolu kontrol edin.',
  'Link başarıyla silindi': 'Link başarıyla silindi',
  'Link kopyalandı!': 'Link kopyalandı!',
  'Ödeme durumu başarıyla güncellendi!': 'Ödeme durumu başarıyla güncellendi!',
  'dosyası okunamadı!': 'dosyası okunamadı!',
  'Tüm dosyalar için SUT kodu ve fiyat kolonlarını seçmelisiniz!': 'Tüm dosyalar için SUT kodu ve fiyat kolonlarını seçmelisiniz!',
  'Yüklenecek geçerli satır bulunamadı! Lütfen dosya(lar)da SUT kodu ve fiyatı dolu satır olduğundan emin olun.': 'Yüklenecek geçerli satır bulunamadı! Lütfen dosya(lar)da SUT kodu ve fiyatı dolu satır olduğundan emin olun.',
  'Yükleme sırasında hata oluştu!': 'Yükleme sırasında hata oluştu!',
  'Otomatik etiket ekleme başarısız!': 'Otomatik etiket ekleme başarısız!',
  'Etiketler başarıyla güncellendi!': 'Etiketler başarıyla güncellendi!',
  'Etiketler güncellenirken hata oluştu!': 'Etiketler güncellenirken hata oluştu!',
  'Resim başarıyla yüklendi!': 'Resim başarıyla yüklendi!',
  'Resim yüklendi ama ürün güncellenemedi!': 'Resim yüklendi ama ürün güncellenemedi!',
  'Resim yüklenirken hata oluştu!': 'Resim yüklenirken hata oluştu!',
  'Ürün başarıyla güncellendi!': 'Ürün başarıyla güncellendi!',
  'Ürün güncellenirken hata oluştu!': 'Ürün güncellenirken hata oluştu!',
  'Hata:': 'Hata:',
  'Güncelleme hatası:': 'Güncelleme hatası:',
  'Alanlar yüklendi:': 'Alanlar yüklendi:',
  'alan': 'alan',
  'Connect Free!': 'Ücretsiz Bağlan!',
  'En çok tercih edilen ürünlerimizi keşfedin': 'En çok tercih edilen ürünlerimizi keşfedin',
  'Tüm Kategoriler': 'Tüm Kategoriler',
  '48 ürün gösteriliyor (Toplam: 8000+)': '48 ürün gösteriliyor (Toplam: 8000+)',
  'Tüm Ürünleri Gör →': 'Tüm Ürünleri Gör →',
  'Detaylar': 'Detaylar',
  'Sipariş Ver': 'Sipariş Ver',
  'Giriş Yap': 'Giriş Yap',
  'Hesabınıza giriş yapın': 'Hesabınıza giriş yapın',
  'This site is protected by reCAPTCHA and the Google Privacy Policy and Terms of Service apply.': 'Bu site reCAPTCHA ile korunmaktadır ve Google Gizlilik Politikası ve Hizmet Şartları geçerlidir.',
  'Ürün Kataloğumuz': 'Ürün Kataloğumuz',
  '8000+ ürün çeşitliliği ile hizmetinizdeyiz': '8000+ ürün çeşitliliği ile hizmetinizdeyiz',
  '1,3B': '1,3B',
  'Partner': 'Partner',
  '8,4M': '8,4M',
  'Toplam Üretim': 'Toplam Üretim',
  '23': '23',
  'Branş': 'Branş',
  '27,5B': '27,5B',
  'Toplam Sipariş': 'Toplam Sipariş',
  'Connect Now': 'Şimdi Bağlan',
  'Tüm bilgilere tek bir yerden erişebilmek için ücretsiz kaydolun.': 'Tüm bilgilere tek bir yerden erişebilmek için ücretsiz kaydolun.',
  'Ürün Detayları': 'Ürün Detayları',
  'Kapat': 'Kapat',
  'Yükleniyor...': 'Yükleniyor...',
  'Hata': 'Hata',
  '{{count}} ürün gösteriliyor (Toplam: 8000+)': '{{count}} ürün gösteriliyor (Toplam: 8000+)',
}; 